
import React from 'react';
import { GraduationCap, BookOpen, Users, Target } from 'lucide-react';
import ComingSoonLayout from '../components/layout/ComingSoonLayout';

const Program: React.FC = () => {
  return (
    <ComingSoonLayout
      title="Program KKN"
      subtitle="Program Kuliah Kerja Nyata"
      description="Halaman ini akan menampilkan informasi lengkap tentang program-program KKN yang akan dilaksanakan di Desa Karangmalang, termasuk jadwal kegiatan."
      icon={<GraduationCap className="h-12 w-12 sm:h-16 sm:w-16 text-white" />}
     
      estimatedDate="Launching Soon"
    />
  );
};

export default Program;